import { useTheme } from "@mui/material";
import React from "react";
import {
  PolarAngleAxis,
  RadialBar,
  RadialBarChart,
  ResponsiveContainer,
} from "recharts";

interface MicroRingChartProps {
  value: number;
  color?: string;
}

export const MicroRingChart = (props: MicroRingChartProps) => {
  const theme = useTheme();

  return (
    <RadialBarChart
      width={30}
      height={30}
      cx="50%"
      cy="50%"
      data={[
        { value: props.value, fill: props.color || theme.palette.grey[100] },
      ]}
      innerRadius="100%"
      outerRadius="200%"
      barSize={6}
      startAngle={90}
      endAngle={-270}
    >
      <PolarAngleAxis
        type="number"
        domain={[0, 1]}
        angleAxisId={0}
        tick={false}
      />

      <RadialBar
        dataKey="value"
        angleAxisId={0}
        cornerRadius={3}
        background={{
          fill: theme.palette.grey[100],
        }}
      />
    </RadialBarChart>
  );
};
